<template>
  <div class="d-flex align-center" @mouseover="isStudentRowHovered = true" @mouseleave="isStudentRowHovered = false">
    <div>
      <router-link target="_blank" style="text-decoration: none" :to="'/student/' + student.id">
        {{ student.name }}
      </router-link>

      <div class="text-caption grey--text font-weight-medium ml-2" v-if="isDefaultAbsent">
        Mặc định không đi
      </div>
    </div>
    <v-icon
      v-if="isStudentRowHovered"
      class="ml-2"
      color="orange"
      @click="() => $emit('on-edit-default-absent', student)"
    >
      mdi-account-alert-outline
    </v-icon>
  </div>
</template>
<script>
import { get } from 'lodash'
export default {
  props: {
    student: Object,
    item: Object
  },
  data() {
    return {
      isStudentRowHovered: false
    }
  },
  computed: {
    isDefaultAbsent() {
      return get(this.item, 'defaultAbsentStudents', []).includes(this.student.id)
    }
  }
}
</script>
